/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRemoteSessionIssuerForm,
  UpdateRemoteSessionIssuerForm$Outbound,
  UpdateRemoteSessionIssuerForm$outboundSchema,
} from "../components/updateremotesessionissuerform.js";

export type UpdateOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type UpdateOrganizationRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  updateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm;
};

/** @internal */
export type UpdateOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const UpdateOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationRemoteSessionIssuerSecurity$Outbound,
    UpdateOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function updateOrganizationRemoteSessionIssuerSecurityToJSON(
  updateOrganizationRemoteSessionIssuerSecurity:
    UpdateOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      updateOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateOrganizationRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  UpdateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm$Outbound;
};

/** @internal */
export const UpdateOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    UpdateOrganizationRemoteSessionIssuerRequest$Outbound,
    UpdateOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      updateRemoteSessionIssuerForm:
        UpdateRemoteSessionIssuerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        updateRemoteSessionIssuerForm: "UpdateRemoteSessionIssuerForm",
      });
    }),
  );

export function updateOrganizationRemoteSessionIssuerRequestToJSON(
  updateOrganizationRemoteSessionIssuerRequest:
    UpdateOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    UpdateOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      updateOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
